import { useState } from 'react';
import { Position } from 'reactflow';
import { BaseNode } from './BaseNode';

export const APINode = ({ id, data }) => {
  const [method, setMethod] = useState(data?.method || 'GET');
  const [endpoint, setEndpoint] = useState(data?.endpoint || 'https://api.example.com');

  const config = {
    title: 'API Request',
    fields: [
      {
        name: 'method',
        type: 'select',
        label: 'Method',
        value: method,
        onChange: (e) => setMethod(e.target.value),
        options: ['GET', 'POST', 'PUT', 'DELETE', 'PATCH'],
      },
      {
        name: 'endpoint',
        type: 'text',
        label: 'Endpoint',
        value: endpoint,
        onChange: (e) => setEndpoint(e.target.value),
        placeholder: 'https://...',
      },
    ],
    handles: [
      {
        type: 'target',
        position: Position.Left,
        id: `${id}-headers`,
        style: { top: '33%' },
      },
      {
        type: 'target',
        position: Position.Left,
        id: `${id}-body`,
        style: { top: '66%' },
      },
      {
        type: 'source',
        position: Position.Right,
        id: `${id}-response`,
        style: { top: '40%' },
        className: '!bg-blue-500',
      },
      {
        type: 'source',
        position: Position.Right,
        id: `${id}-error`,
        style: { top: '60%' },
        className: '!bg-red-500',
      },
    ],
    width: 240,
    height: 160,
  };

  return <BaseNode id={id} data={data} config={config} />;
};